angular.module('angus.controllers').controller('alertResultsWidgetController', [
    '$q', '$rootScope', '$scope','actionViewTemplates', 'alertsFrameworkService', 'modalService',
    function($q, $rootScope, $scope, actionViewTemplates, alertsFrameworkService, modalService) {
        const subscriberKey = $rootScope.user.subscriberAbosKey;

        function loadWidget() {
            const alertKey = $scope.widget.instance.settings.alertKey;

            if (!alertKey) {
                return $scope.widget.promises.monitor($q.resolve());
            }

            const promise = alertsFrameworkService.getAlertResultsCounts(subscriberKey, alertKey)
                .then(counts => {
                    $scope.resultsCount = counts.resultsCount;
                    $scope.totalCount = counts.totalCount;
                });

            return $scope.widget.promises.monitor(promise);
        }

        $scope.widget.setDefaultInitialization(loadWidget);    

        $scope.$on('widgetSettingsChanged', function() {
            loadWidget();
        });
        function getValue(obj, key) {
            return obj && obj[key] && obj[key].value != null && obj[key].value != "" ? +obj[key].value : undefined;
        }

        $scope.getResultsClass = function(resultsCount, widget) {
            const widgetInstanceSettings = widget.instance.settings;
            const target = getValue(widgetInstanceSettings, 'unresolvedResultsTarget');
            const warning = getValue(widgetInstanceSettings, 'unresolvedResultsWarningLevel');
            const targetPulse = getValue(widgetInstanceSettings, 'unresolvedResultsTargetPulse');
            const warningPulse = getValue(widgetInstanceSettings, 'unresolvedResultsWarningLevelPulse');

            if (resultsCount <= target) {
                return 'text-success';
            }else if (resultsCount >= warning) {
                return `text-danger ${warningPulse ? 'pulse' :  ''}` ;
            }else if (resultsCount > target) {
                return `text-warning ${targetPulse ? 'pulse' : ''}`;
            }
            
            return '';
        };
        $scope.resultsClicked = (showHidden) => {
            const scope = {
                widgetName: 'Alert Results',
                widgetIcon: `table`,
                widgetId: 'AlertResults',
                widgetCode: 'AlertResults',
                settings: {},
                model: {
                    subscriberKey: subscriberKey, 
                    alertKey: $scope.widget.instance.settings.alertKey,
                    showHidden: showHidden
                }
            };

            modalService.openActionView(actionViewTemplates.alertResults, scope, 'AlertResults');
        }

    }
])